export const giveScreenReaderFeedback = (text: string, repeatIfSame: boolean = false) => {
	const feedbackBox = document.querySelector('#feedback');
	if (feedbackBox === null) return;

	if (repeatIfSame && feedbackBox.innerHTML === text) {
		// Add or remove the period from end to make the text slightly different
		if (text.endsWith('.')) {
			text = text.substring(0, text.length - 1);
		} else {
			text = text + '.';
		}
	}

	feedbackBox.innerHTML = '';
	const textnode = document.createTextNode(text);
	feedbackBox.appendChild(textnode);
};

export const timeToScreenReaderText = (totalSeconds: number): String => {
	let text = '';
	const mins = Math.floor(totalSeconds / 60);
	if (mins > 1) {
		text += `${mins} minutes `;
	} else if (mins > 0) {
		text += `${mins} minute `;
	}

	const secs = totalSeconds % 60;
	if (secs > 0 || text === '') {
		let secsText = secs.toFixed(2).replace(/\.?0+$/g, ''); // Remove trailing 0s
		if (secsText === '1') {
			text += '1 second ';
		} else {
			text += `${secsText} seconds `;
		}
	}

	return text;
};
